import VueChartJS from 'vue-chartjs';
import ChartJSDatalabels from 'chartjs-plugin-datalabels';
import Chart from 'chart.js'


Chart.plugins.unregister(ChartJSDatalabels);
Chart.plugins.register(ChartJSDatalabels);

export default{
    extends:VueChartJS.Line,
    //props:["data","page","url","tooltipaftertitle","toggleLegend"],
    props: {
		data: [],
		page: 0,
		url: '',
		tooltipaftertitle: [],
		totalValue: '',
		disable: false,
		showlegend: {
			type: Boolean,
			default: true
		},
		legendPosition: {
            type: String,
            default: 'bottom'
        },
        toggleLegend: {
            type: Boolean, // Nilai: "checkAll" atau "uncheckAll"
            default: true
        },
	},

    methods:{
        redraw() {
            let datas = {
                labels:["2014","2015","2016","2017","2018","2019","2020","2021"],
                datasets:[
                    {
                        label:"Pertamax",
                        hidden:false,
                        data:[22,27,55,11,27,27,55,11],
                        stack:"sum",
                        borderColor: "#FF6384",
                        backgroundColor: "#FF6384",
                        fill: false,
                        tension: 0.1,
                    },
                    {label:"Pertalite",hidden:false ,data:[11,19,22,33,11,19,22,33],stack:"sum"},
                    {label:"Premium",hidden:false ,data:[17,25,44,12,17,25,44,12],stack:"sum"},
                ]
            }

            let data1 = this.data
            //console.log('data1: ' + JSON.stringify(data1))

            var options = {
                responsive:true,
                maintainAspectRasio:false,
                legend:{
                    display: true,
                    position: 'bottom',
                    labels: {
                        font: {
                            size: 8
                        },
                        usePointStyle: false, // Opsional, membuat bentuk legend lebih menarik
                    },
                    onHover: (event, legendItem) => {
                        const datasetIndex = legendItem.datasetIndex;
                        const chart = this.$data._chart;

                        // Ubah cursor menjadi pointer saat hover di legend
                        //event.native.target.style.cursor = "pointer";
                        chart.canvas.style.cursor = "pointer";
                        /*
                        chart.data.datasets.forEach((dataset, index) => {
                            dataset.backgroundColor = index === datasetIndex
                                ? dataset.originalBackgroundColor
                                : 'rgba(0, 0, 0, 0.1)'; // Membuat dataset lain transparan
                        });

                        chart.update();
                        */
                    },
                    onLeave: (event) => {
                        const chart = this.$data._chart;

                        // Kembalikan cursor ke default setelah leave
                        //event.native.target.style.cursor = "default";
                        chart.canvas.style.cursor = "default";
                        /*
                        chart.data.datasets.forEach(dataset => {
                            dataset.backgroundColor = dataset.originalBackgroundColor;
                        });

                        chart.update();
                        */
                    }
                },
                title: {
                    display: false,
                    text: 'Penerimaan'
                },
                tooltips:{
					enabled: true,
					intersect:false,
					mode:'index', //index
					callbacks: {

						label: function(tooltipItem, data) {
							//let label = data.labels[tooltipItem.index];
							var dstLabel = data.datasets[tooltipItem.datasetIndex].label;
							//var yLabel = tooltipItem.yLabel;
							return dstLabel +': '+tooltipItem.yLabel.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
						},
                    },
                },
                scales:{
                    yAxes:[
                        {
                            gridLines:{
                                offsetGridLines: false,
                                tickMarkLength: false,
                                drawTicks: false,
                                zeroLineColor:'transparent',
                                display:true,
                                borderDash:[10],
                                color:'rgba(255,0,0,.125)',
                            },
                            ticks: {
                                beginAtZero: true,
                                display:true,
                                padding:10,
                                callback: function(value, index, values) {
                                    /*
									if(value >= 1000000000 ) {
										let legend = value/1000000000;//String(value).substr(0, 3);
										return legend.toLocaleString('en-US') + ' B';
									}
                                    */

									if(value >= 1000000 ) {
										let legend = value/1000000;//String(value).substr(0, 3);
										return legend.toLocaleString('en-US') + ' M';
									}

									if(value >= 100000) {
										let legend = value/1000;//String(value).substr(0, 3);
										return legend.toLocaleString('en-US') + ' K';
									}

                                    //below 0


									if(value <= -1000000000) {
										let legend = value/1000000000;//String(value).substr(0, 3);
										return legend.toLocaleString('en-US') + ' B';
									}

                                    if(value <= -1000000) {
										let legend = value/1000000;//String(value).substr(0, 3);
										return legend.toLocaleString('en-US') + ' M';
									}

                                    if(value <= -100000) {
										let legend = value/1000;//String(value).substr(0, 3);
										return legend.toLocaleString('en-US') + ' K';
									}

									return value;

								},
                            }
                        }
                    ],
                    xAxes:[
                        {
                            gridLines:{
                                offsetGridLines: false,
                                tickMarkLength: false,
                                drawTicks: false,
                                zeroLineColor:'transparent',
                                display:true,
                                borderDash:[10],
                                color:'rgba(0,0,255,.125)',
                            },
                            ticks: {
                                beginAtZero: true,
                                display:true,
                                padding: 10
                            }
                        }
                    ]
                },

                plugins: {
                    datalabels: {
                      display: false,
                      align: "top",
                      anchor: "end",
                      font: {
                        size: 10
                      },
                      formatter: value => value, // Menampilkan angka di tiap titik
                      color: "#000"
                    }
                  }
            }

            //this.addPlugin(ChartJSDatalabels);
            //this.register(ChartJSDatalabels);
            this.renderChart(data1, options);
            //this.renderChart(datas,options)
        },
        checkAllLegend() {
            const chart = this.$data._chart;
            chart.data.datasets.forEach(dataset => {
                dataset.hidden = false;
            });
            //chart.update();
        },

        // Method untuk menyembunyikan semua dataset (uncheck all)
        uncheckAllLegend() {
            const chart = this.$data._chart;
            chart.data.datasets.forEach(dataset => {
                dataset.hidden = true;
            });
            //chart.update();
        }
    },
    mounted() {
        this.redraw();
    },
    watch: {
		data: function() {
			this.redraw();
		},
        // Watch untuk prop toggleLegend
        toggleLegend(newVal) {
            if (newVal === true) {
                this.checkAllLegend();
            } else {
                this.uncheckAllLegend();
            }
        }
	}
}
